/**
 * @deprecated prefer to use orgId2 instead. This format for orgId is rarely found in prod organizations.
 */
export const orgId1 = 'crazy-craig';
export const org1Recipient = `domain.${orgId1}.role`;

export const nanoIdForOrg2 = '9a1sg2d';
export const orgId2 = `wonky-willy-${nanoIdForOrg2}`;
export const org2Recipient = `domain.${orgId2}.role`;

export const testScenarioCookieName = 'test_scenario';
export const testScenarioHeaderName = 'x-test-scenario';
